import { TypographySize } from 'mm-theme-configuration/dist/consts';
import { StyleSheet, StyleDeclarationValue } from 'aphrodite/no-important';

export interface SemanticTagDataProps {
  styles?: StyleDeclarationValue[]
}

export type FontSizesStyles = {
  [key in TypographySize]: {
    [key: string]: {
      fontSize: string
      lineHeight: string
    }
  }
};

export interface SemanticTagThemeProps {
  fontSizesStyles: FontSizesStyles
}

export type SemanticTagProps = SemanticTagDataProps & SemanticTagThemeProps;

export const getStyleBySize = (fontSizesStyle: FontSizesStyles, fontSize: TypographySize) => {
  return StyleSheet.create({
    tagStyle: {
      ...fontSizesStyle[fontSize],
      margin: 0,
    },
  }).tagStyle;
};

export const semanticCSS = (...styles: StyleDeclarationValue[]) => styles;
